import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '../../../api.service'; // Asegúrate de poner la ruta correcta
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { data } from 'jquery';
import { SseService } from 'src/app/services/SseService';
import { ToastrService } from 'ngx-toastr';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { SessionService } from 'src/app/services/session.service';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
/*     standalone: true,
    imports: [
        MatCardModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        CommonModule,
    ], */
})
export class LoginComponent {
    loginForm: FormGroup;
    isLoading = false;
    hide = true;
    recordar: boolean = false;
    password: string = '';
    showPassword: boolean = false;
    constructor(
        private fb: FormBuilder,
        private apiService: ApiService,
        private cookieService: CookieService,
        private router: Router,
        private toastr: ToastrService,
        public themeService: CustomizerSettingsService,
        private _sseService: SseService,
        private dialog: MatDialog,
        private sessionService: SessionService,
    ) {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
        });
    }
    ngOnInit() {
        this.clearAuthCookies();

        if (this.cookieService.check('auth_token')) {
            this.router.navigate(['/']);
        }
    }

    private clearAuthCookies() {
        console.log('Cookies antes (getAll):', this.cookieService.getAll());

        const names = ['auth_token', 'session_id', 'userId', 'username_logged', 'permisos'];

        // Intento básico (host-only, path /)
        names.forEach(n => this.cookieService.delete(n, '/'));

        // Intento con dominio explícito subdominio
        names.forEach(n => this.cookieService.delete(n, '/', 'app.nectum-investment.com'));

        // Intento con dominio padre (si el backend la puso como .nectuminvestment.com)
        names.forEach(n => this.cookieService.delete(n, '/', '.nectum-investment.com'));

        // (Opcional) limpiar cualquier otra cookie propia sin dominio
        // this.cookieService.deleteAll('/');

        console.log('Cookies después (getAll):', this.cookieService.getAll());
        console.log('document.cookie visible:', document.cookie);
    }

    togglePassword(): void {
        this.showPassword = !this.showPassword;
      }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    Recordar(event: any) {
        this.recordar = event.checked;
    }

    openForgotPassword(): void {
        this.dialog.open(ForgotPasswordComponent, {
            width: '420px',
            maxWidth: '95vw',
            panelClass: 'forgot-password-panel',
        });
    }

      

    onLogin() {

        console.log("entre al metodo");
        if (this.loginForm.valid) {
            this.login(false);
        }else{
            console.log("no esta validado el formulario")
        }
    }

    /** Sesión única: con forzar=false el backend avisa si hay otra sesión abierta en otro equipo. */
    private login(forzar: boolean) {
            this.isLoading = true;
            this.apiService
                .apiPost(
                    'obtener_licencia',
                    false,
                    {
                        idusuario: this.loginForm.value?.email,
                        clave: this.loginForm.value?.password,
                        mac: this.sessionService.getDeviceId(),
                        forzar,
                        recordar: !!this.recordar,
                    },
                    2
                )
                .then(
                    (response: any) => {
                        console.log("RESPONDE LOGIN ", response );
                        if (response?.data?.sesion_activa) {
                            this.isLoading = false;
                            this.confirmarCerrarOtraSesion();
                            return;
                        }
                        if (!!response?.data?.item) {

                            if(response.data.dias > 0){
                                this.cookieService.set(
                                    'auth_token',
                                    response.data?.item,
                                    !!this.recordar ? 7 : undefined
                                );
                                this.cookieService.set(
                                    'session_id',
                                    response.data?.session_id ?? '',
                                    !!this.recordar ? 7 : undefined,
                                    '/'
                                );
                                this.cookieService.set(
                                    'userId',
                                    response.data?.userId,
                                    !!this.recordar ? 7 : undefined
                                );
                                this.cookieService.set(
                                    'username_logged',
                                    this.loginForm.value?.email,
                                    !!this.recordar ? 7 : undefined
                                );
                                this.cookieService.set(
                                    'user_type_id',
                                    response.data?.user_type_id,
                                    !!this.recordar ? 7 : undefined
                                );
                                this.cookieService.set(
                                    'order_type_id',
                                    response.data?.order_type_id,
                                    !!this.recordar ? 7 : undefined
                                );
                                this.cookieService.set(
                                    'order_type_name',
                                    response.data?.order_type_name,
                                    !!this.recordar ? 7 : undefined
                                );
                                this.cookieService.set(
                                    'permisos',
                                    JSON.stringify(response.data?.permisos ?? {}),
                                    !!this.recordar ? 7 : undefined
                                );
                                this._sseService.updateLogin(true);
                                this.sessionService.startHeartbeat();

                                this.router.navigate(['/models']);
                            }else{
                                this.toastr.error('Licencia expirada.', 'Acceso Denegado', {
                                    timeOut: 3000,
                                    positionClass: 'toast-top-center'
                                });
                            }
                        } else {        
                            this.toastr.error('Usuario / Contraseña incorrecta.', 'Error de Autenticación', {
                                timeOut: 3000,
                                positionClass: 'toast-top-center'
                            });
                        }
                        this.isLoading = false;
                    },
                    (error: any) => {
                        this.toastr.error('Error de conexión, intente nuevamente.', 'Error', {
                            timeOut: 3000,
                            positionClass: 'toast-top-right'
                        });

                        this.isLoading = false;
                    }
                );
    }

    private confirmarCerrarOtraSesion() {
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                icon: 'devices',
                titulo: 'Sesión activa en otro equipo',
                msj: 'Ya tienes una sesión iniciada en otro equipo. Si continúas, esa sesión se cerrará.',
                botonAceptar: 'Continuar',
                botonCancelar: 'Cancelar',
            },
        }).afterClosed().subscribe((continuar: boolean) => {
            if (continuar) {
                this.login(true);
            }
        });
    }
}
